// extracted by mini-css-extract-plugin
export default {"page":"KX-z","cartModal":"LX-z","checkout":"MX-z","placeholder":"NX-z","account":"OX-z"};